import { EmpresasService } from './../../../services/empresas/empresas.service';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import Swal from "sweetalert2";

@Component({
  selector: 'app-detalle-configuracion-cm',
  templateUrl: './detalle-configuracion-cm.component.html',
  styleUrls: ['./detalle-configuracion-cm.component.scss']
})
export class DetalleConfiguracionCmComponent implements OnInit {

  @Output() cerrarPopUp : EventEmitter<boolean> = new EventEmitter();
  form : FormGroup;
  idCobranza_Judicial:any;
  data:any;
  loading: boolean;
  newArray:any=[];
  lineaSoles:any;
  lineaDolares:any;

  Firma:any;
  PagoInteres:any;
  Tasa:any
  PorcentajeAdelanto:any;
  GastosAsociados:any;
  IDCMarco:any;

  constructor(private empresasService : EmpresasService ) {
  this.IDCMarco = empresasService.dataContratoMarco.IDCMarco;
  }

  ngOnInit() {
    this.form = new FormGroup({
      idConfiguracionConfirming : new FormControl({ value: "", disabled: true }),
      FlagFirmaDesembolso : new FormControl({ value: "", disabled: true }),
      FlagPagoInteres : new FormControl({ value: "", disabled: true }),
      FlagTasa : new FormControl({ value: "", disabled: true }),
      FlagPorcentajeAdelanto : new FormControl({ value: "", disabled: true }),
      FlagGastosAsociados : new FormControl({ value: "", disabled: true }),
      TasaMinima : new FormControl({ value: "", disabled: true }),
      TasaMaxima : new FormControl({ value: "", disabled: true }),
      PorcentajeAdelantoMinimo : new FormControl({ value: "", disabled: true }),
      PorcentajeAdelantoMaximo : new FormControl({ value: "", disabled: true }),
      GastoMinimo : new FormControl({ value: "", disabled: true }),
      GastoMaximo : new FormControl({ value: "", disabled: true }),
      LineaTotalSoles : new FormControl({ value: "0.00", disabled: true }),
      LineaDisponibleSoles : new FormControl({ value: "0.00", disabled: true }),
      LineaEjecutadaSoles : new FormControl({ value: "0.00", disabled: true }),
      LineaTotalDolares : new FormControl({ value: "0.00", disabled: true }),
      LineaDisponibleDolares : new FormControl({ value: "0.00", disabled: true }),
      LineaEjecutadaDolares : new FormControl({ value: "0.00", disabled: true }),
    })
    
    this.obtenerConfigConfirming(this.IDCMarco);
  }

  
  obtenerConfigConfirming(IDCMarco:any){

     this.empresasService.obtenerConfigConfirming(IDCMarco).subscribe(
       res =>{
           if (res[0]['FlagFirmaDesembolso'] == 0) {
             this.Firma = "No"
           }else{
            this.Firma = "SI"
           }
           if (res[0]['FlagPagoInteres'] == 0) {
            this.PagoInteres = "No"
          }else{
           this.PagoInteres = "SI"
          }
          if (res[0]['FlagTasa'] == 0) {
            this.Tasa = "No"
          }else{
           this.Tasa = "SI"
          }
          if (res[0]['FlagPorcentajeAdelanto'] == 0) {
            this.PorcentajeAdelanto = "No"
          }else{
           this.PorcentajeAdelanto = "SI"
          }
          if (res[0]['FlagGastosAsociados'] == 0) {
            this.GastosAsociados = "No"
          }else{
           this.GastosAsociados = "SI"
          }
           

           this.form.controls['idConfiguracionConfirming'].setValue(res[0]['idConfiguracionConfirming']); 
           this.form.controls['FlagFirmaDesembolso'].setValue(this.Firma); 
           this.form.controls['FlagPagoInteres'].setValue(this.PagoInteres); 
           this.form.controls['FlagTasa'].setValue(this.Tasa); 
           this.form.controls['FlagPorcentajeAdelanto'].setValue(this.PorcentajeAdelanto); 
           this.form.controls['FlagGastosAsociados'].setValue(this.GastosAsociados); 
           this.form.controls['TasaMinima'].setValue(res[0]['TasaMinima']); 
           this.form.controls['TasaMaxima'].setValue(res[0]['TasaMaxima']); 
           this.form.controls['PorcentajeAdelantoMinimo'].setValue(res[0]['PorcentajeAdelantoMinimo']); 
           this.form.controls['PorcentajeAdelantoMaximo'].setValue(res[0]['PorcentajeAdelantoMaximo']); 
           this.form.controls['GastoMinimo'].setValue(res[0]['GastoMinimo']); 
           this.form.controls['GastoMaximo'].setValue(res[0]['GastoMaximo']); 
           
  
           for( let item of res[0].LineaMonetaria){
              this.newArray.push(item)
           }

           this.lineaSoles = this.newArray[0].LineaTotal
           this.lineaDolares = this.newArray[1].LineaTotal
           this.form.controls['LineaTotalSoles'].setValue(this.newArray[0].LineaTotal);
           this.form.controls['LineaDisponibleSoles'].setValue(this.newArray[0].LineaDisponible);
           this.form.controls['LineaEjecutadaSoles'].setValue(this.newArray[0].LineaEjecutada);
           this.form.controls['LineaTotalDolares'].setValue(this.newArray[1].LineaTotal);
           this.form.controls['LineaDisponibleDolares'].setValue(this.newArray[1].LineaDisponible);
           this.form.controls['LineaEjecutadaDolares'].setValue(this.newArray[1].LineaEjecutada);
           this.loading = false;
       },err =>{
           Swal.fire({
               title: "¡Algo salió mal!",
               text:  err.error['error'],
               type: "warning",
               allowOutsideClick: true,
               heightAuto: false 
           });
           this.loading = false;
       }
     )
  
  
    }

  CerrarPopUp(){
    this.cerrarPopUp.emit();
  }

}
